// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  invisible: { display: "none" },
  video: {
    position: "fixed",
    top: 0,
    left: 0,
    width: 320,
    height: 180
  }
}), { index: 1 })